/** @jsxImportSource theme-ui */
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Flex, Heading, Link, Spinner, Text } from 'theme-ui';
import Button from '@/components/Button';
import Error from '@/components/Error';
import { CompanyEmbedData, useCompanyEmbedData } from './useCompanyEmbedData';
import EmbedColumns from './EmbedColumns';

const CompanyEmbed: React.FC = () => {
    const { companyId } = useParams<{ companyId: string }>();
    const navigate = useNavigate();
    const data = useCompanyEmbedData(companyId);

    return (
        <Box>
            <Flex sx={{ alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
                <Heading as="h2">Embed & preview</Heading>
                <Button
                    type="button"
                    variant="secondary"
                    onClick={() => navigate(`/clients/${companyId}`)}
                >
                    Back to company
                </Button>
            </Flex>
            <EmbedPageBody companyId={companyId} data={data} />
        </Box>
    );
};

const EmbedPageBody: React.FC<{ companyId?: string; data: CompanyEmbedData }> = ({
    companyId,
    data,
}) => {
    if (data.companyError) {
        return <Error error={data.companyError as any} text="Could not load company" />;
    }
    if (data.isLoading) return <Spinner size={16} />;
    if (!data.embedScriptUrl) {
        return (
            <Text>REACT_APP_EMBED_JS_NEXT is not configured or the company has no site path.</Text>
        );
    }
    if (data.configurations.length === 0) {
        return (
            <Text>
                No widget configurations found.{' '}
                <Link href={`/#/clients/${companyId}/widget/configurations`}>Create one</Link>
            </Text>
        );
    }
    return <EmbedColumns data={data} />;
};

export default CompanyEmbed;
